const $ = require('jquery');

export default {
  init() {
    let width = 0;
    $('.pill').each((i: any, e: any) => {
      width += $(e).outerWidth() + 10;
    });
    $('.pills__inner').width(width + 14);
  }
};
